import { useQuery } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import { GetAdditionalFeesQuery } from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetAdditionalFees {
		getAdditionalFees {
			_id
			name
			isOfferingHigherValue
			isDeactivated
			configs {
				type
				discountType
				discountValue

				products
				types
				options
				categories
				agents
				clients
			}
		}
	}
`;

export type GetAdditionalFeesResults =
	GetAdditionalFeesQuery["getAdditionalFees"];

export const getAdditionalFeesQueryKey = () => ["getAdditionalFees"];

export const useGetAdditionalFees = (enabled?: boolean) => {
	return useQuery({
		enabled: enabled ?? true,
		queryKey: getAdditionalFeesQueryKey(),
		queryFn: async () =>
			apiGqlClient.request(graphql(query)).then((res) => res.getAdditionalFees),
	});
};

export const useGetAdditionalFeesCache = () => {
	return useGetAdditionalFees(false);
};
